<template>
  <div>
    <div class="selector-down">
      <div class="triangle"></div>
     
      <div class="selector-option">
        <ul class="option">
          <li
            v-for="(item, index) in optionList"
            :key="item.fnTagId "
            @click.stop="seletHander(item, index)"
            v-bind:class="{ active: active == index }"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,//月龄下标
      optionList:[],//月龄数组
    };
  },
 props:{
    monthAgeData:{
      type:Array,
      default:[]
    }
  },
  watch: {
    monthAgeData: {
      handler(newVal, oldVal) {
        {
          
          this.optionList=[...this.optionList,...newVal]
          
        }
      },
      deep: true,
    },
  },
  methods: {
    closeUp() {
      $(".selector-down").slideUp();
    },
    closeDown() {
      $(".selector-down").slideDown();
      $(".search-class").fadeOut(100);
    },
    /**
     * @description: 点击月龄
     * @param {item} 当前月龄信息
     * @param {index} 月龄下标
     * @return {*}
     */    
    seletHander(item, index) {
      this.active = index;
      this.$emit("sendSelect", {
        info: item,
        flag: true,
       
      });

      this.closeUp();
    },
  },
};
</script>
<style lang="less" scoped>
//选项
.selector-down {
  position: fixed;
  top: 45px;
  left: 0;
  z-index: 100;
  text-align: center;
  display: none;
  .triangle {
    width: 0;
    height: 0;
    border: 5px solid transparent; //所有border都是透明的，
    border-bottom-color: #d4a437; //只有尖相对的方向border有颜色
    position: fixed;
    left: 53px;
  }
  .selector-option {
    padding-top: 10px;
    width: 116px;
    // height:240px;
    background: @expertFontColor255;
    box-shadow: 1px 3px 3px 0px rgba(142, 142, 142, 0.2);
    // border-top: 1px solid #F1F1F1;
    .active {
      color: #d4a437;
    }
    .option {
      line-height: 39px;
      font-size: @indexFontSize14;
    }
  }
}
</style>
